import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const Subtitle = styled.div `
  margin-top: var(--space-200);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-400);
  color: var(--text-secondary);
  text-align: center;

  a {
    text-decoration: underline;

    &:hover {
      color: var(--text-primary);
    }
  }
`;
export const ButtonWrapper = styled.div `
  margin-top: var(--space-600);
  margin-bottom: var(--space-600);
`;
